import {
  INCREMENT_LIGHTBOX_KEY,
  SET_LAYER_VISIBILITY,
  SET_LIGHTBOX_SOURCE_INDEX,
  SET_LIGHTBOX_SOURCES,
  SET_ACTIVE_MODAL,
  SET_MODAL_TEMPLATES,
  SET_TOPIC_LAYERS,
  TOGGLE_LIGHTBOX_STATE,
} from "../constants/ActionTypes";

// Action creators for the Lightbox state.
const incrementLightboxKey = () => ({
  type: INCREMENT_LIGHTBOX_KEY,
});

const setLightboxSourceIndex = (sourceIndex) => ({
  type: SET_LIGHTBOX_SOURCE_INDEX,
  sourceIndex,
});

const setLightboxSources = (sources) => ({
  type: SET_LIGHTBOX_SOURCES,
  sources,
});

const toggleLightboxState = () => ({
  type: TOGGLE_LIGHTBOX_STATE,
});

// Action creators for the Modal state.
const setActiveModal = (modalId) => ({
  type: SET_ACTIVE_MODAL,
  modalId,
});

const setModalTemplates = (modalTemplates) => ({
  type: SET_MODAL_TEMPLATES,
  modalTemplates,
});

// Action creators for the interactive map
const setLayerVisibility = (layerId, visible) => ({
  type: SET_LAYER_VISIBILITY,
  payload: { layerId, visible },
});

const setTopicLayers = (layerIds) => ({
  type: SET_TOPIC_LAYERS,
  layerIds,
});

export {
  incrementLightboxKey,
  setLayerVisibility,
  setLightboxSourceIndex,
  setLightboxSources,
  setActiveModal,
  setModalTemplates,
  setTopicLayers,
  toggleLightboxState,
};
